import React, { useRef, useState, useEffect } from 'react';
import { Form, Row, Col, Card, Datepicker, Button, Table } from 'react-bootstrap';
import ErrorHandler from '../../controls/ErrorHandler';
import Icon from "../../controls/Icons/Icon";
import { ErrorBoundary } from 'react-error-boundary';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DatePicker from "react-datepicker";
import { dateDisplayFormater, getDateSaveFormat } from '../../../Utils';
import DynamicDropdownSearchable from '../../controls/DynamicDropdownSearchable';
import useFetchWithCancellation from '../../../customhooks/useFetchWithCancellation';

export default function InvoicePayOutTransaction({invId }) {
    const [validated, setValidated] = useState(false);
    const formRef = useRef(null);
    const state = useSelector(state => state);
    const [isInvSelected, setisInvSelected] = useState(false);
    const [data, setData] = useState(null);
    
    const [paymentRecdDate, setpaymentRecdDate] = useState(new Date());
    const [refreshGrid, setrefreshGrid] = useState(false);
    const [gridData, setgridData] = useState({
        fkinvoiceId: state.selPayUpdtData.Id ?? 0,
        ReceivedAmount: 0,
        PaymentDetails: "",
        CreatedDate: "",
        UpdatedDate: "",
        CreatedBy: "",
        ModifiedBy: "",
        ModeofPayment: "",
        paymentDate: "",
        PayoutAmount: 0,
    });

    useEffect(() => {

        if (state.selPayUpdtData && state.selPayUpdtData.Id > 0) {
            fetch(state.projectdetail.API + "/invoice/GetAllInvPayOutDetails?InvId=" + state.selPayUpdtData.Id, {
                method: "Get"
            }).then(response => response.json()).then((res) => {
                if (res) {
                    setgridData(res);
                    console.log(res);
                }
                //navigate("/admin/invoice");
            }).catch((err) => {
                if (err && err.name === 'AbortError') return;
                window.HandleError("Invoice.js ==> Invoice Get", null, null, err);
                console.log(err)
            }).finally(() => {
                //setLoading(false);
            });
        }

    }, [refreshGrid]);

    return (<ErrorBoundary FallbackComponent={ErrorHandler}>
        <Form noValidate validated={validated} ref={formRef}>
            <div>
                <div>
                    {/*View PayOut Transaction*/}
                </div>

                <Card className="border">
                    <Card.Body>
                        <Row>
                            <Col md={2} style={{ border: "1px solid #ccc", background: "#0a4081", color: "white"  }}> Entered By</Col>
                        <Col md={2} style={{ border: "1px solid #ccc", background: "#0a4081", color: "white" }}> Pmt Amt</Col>
                    <Col md={3} style={{ border: "1px solid #ccc", background: "#0a4081", color: "white"  }}> Pmt Mode</Col>
                <Col md={2} style={{ border: "1px solid #ccc", background: "#0a4081", color: "white"  }}> Pmt Date</Col>
            <Col md={3} style={{ border: "1px solid #ccc", background: "#0a4081", color: "white"  }}> Pmt Notes</Col>
                        </Row>
                        {gridData && gridData.length > 0 && gridData.map((rowData) => {
                            return (
                                <Row>
                                    <Col md={2} style={{ border: "1px solid #0a4081", color: "black" }}>
                                        {rowData.CreatedBy}
                                    </Col>
                                    <Col md={2} style={{ border: "1px solid #0a4081", color: "black" }}>
                                        $ {rowData.PayoutAmount}
                                    </Col>
                                    <Col md={3} style={{ border: "1px solid #0a4081", color: "black" }}>
                                        {rowData.ModeofPayment}
                                    </Col>
                                    <Col md={2} style={{ border: "1px solid #0a4081", color: "black" }}>
                                        {dateDisplayFormater(rowData.CreatedDate)}
                                    </Col>
                                    <Col md={3} style={{ border: "1px solid #0a4081", color: "black" }}>
                                        {rowData.PaymentDetails}
                                    </Col>

                                </Row>
                            )
                        })}
                        {gridData.length == 0 &&
                            
                            <Row>
                                <Col md={2}></Col>
                                <Col md={2}></Col>
                                <Col md={3}>No Transactions found</Col>
                                
                            </Row>
                        }
                        <Row></Row>
                    </Card.Body>
                </Card>

            </div>
        </Form>
            </ErrorBoundary>
   )
    }